export default {
  recap: {
    language: 'Language',
    loadingRecap: 'Loading Recap...',
    product: 'Product',
    noPictureBrowser: 'You cannot take pictures in the browser version of the app.',
    differentImageReasonCode: 'Please choose another image reason code.',
    validationError:
      'You have given an invalid response to a question. Please revisit the questions below.',
    page: {
      page: 'Page',
      back: 'Back',
      next: 'Next Page',
      finish: 'Finish',
    },
    partialSaveError:
      'Could not save the incomplete survey. If you change tasks, then come back to this one, your responses may not be saved.',
  },
  payPeriod: {
    title: 'Current Pay Period',
    cycle: 'Cycle',
    delayNote:
      'Please note there will be a delay in updating the Current Pay period page for totals',
    toBePaidHours: 'To be paid hours',
    toBePaid: 'To be paid',
    expenses: 'Expenses',
    time: 'Time',
    orderItems: 'Order Items',
    edits: 'Edits',
    lastUpdated: 'Last Updated',
    accepted: 'Accepted',
    declined: 'Declined',
    fixBy: 'Fix by ',
    incomplete: 'Incomplete',
    processing: 'Processing',
  },
  timeline: {
    welcome: 'Welcome',
    pleaseSync: 'Please sync to start using FHS Next Gen',
    initializing: 'Initializing FHS Next Gen',
    expenses: 'Expenses',
    totalTime: 'Total Time',
    current: 'Current',
    miles: 'Miles',
    km: 'Kilometers',
  },
  timecard: {
    denied: 'You have a denied timecard.',
    approved: 'This timecard has been approved',
    processing: 'This timecard is locked and being processed by your manager.',
    processingOpen:
      'This timecard is locked and being processed by your manager. To add activities or expenses re-open and submit the timecard.',
    syncing: 'This timecard is will be synced.',
    declined: 'This timecard has issues that need to be fixed.',
    elapsed:
      'This payroll period has elapsed. Please initiate End of Day sync and contact your manager.',
    incomplete: 'This timecard is incomplete please send to continue using FHS Next Gen.',
    editing: 'You are currently editing a timesheet for',
    doneFixing: 'Done Fixing',
    openTimecard: 'Open timecard',
  },
  activities: {
    storeTask: 'Store Task',
    travel: 'Travel',
    store: 'Store Visit',
    communication: 'Communication',
    material: 'Material Coordination',
    coupon: 'Coupon Returns',
    break: 'Break',
    training: 'Training',
    team: 'Team Based Activity',
    other: 'Misc/Other',
  },
  sideNav: {
    messages: 'Messages',
    expenses: 'Expenses',
    activities: 'Activities',
    profile: 'Profile',
    settings: 'Settings',
    support: 'Support',
    signOut: 'Sign Out',
    currentPayPeriod: 'Current Pay Period',
  },
  settings: {
    profileOptions: 'Profile Options',
  },
  form: {
    maintenance: 'Maintenance',
    maintenanceMessage: 'FHS is undergoing brief maintenance. Please try again shortly.',
    job: 'Job',
    wave: 'Wave',
    downloadPDFs: 'Download PDFs',
    deletePDFs: 'Delete PDFs',
    deleteFilter: 'Delete filter',
    updateFilter: 'Update filter',
    logoutRmActivities:
      'Logging in as a different user will remove any activities that have not been synced.',
    logoutTimecardNotSub: 'You are working on a timecard that has not yet been submitted.',
    logoutWipeActivities: 'Logging out will wipe your activities for the day.',
    logoutDestructive: 'This is a destructive action and cannot be undone. Are you sure?',
    warning: 'Warning',
    logout: 'Logout',
    agree: 'Agree',
    disagree: 'Disagree',
    updateStatus: 'Update Status',
    bulkUpdateRai: 'Bulk Update Rai',
    bulkUpdateRaiNote:
      'Note: bulk updates only apply to non-merch tasks that have a current start date.',
    bulkUpdateRaiFilter: 'You may apply a filter to see tasks that are available to bulk update.',
    bulkUpdateRaiNotApplicable: 'RAI code must be applicable to all selected tasks.',
    wipeData: 'Clear data from device',
    promptStoreVisit: 'Store Visit activity can be started only in the Work View Stores page.',
    promptDeleteActivityHeader: 'Delete Activity',
    promptDeleteActivity: 'Are you sure you would like to delete this activity?',
    endCurrentMessage: 'End current running activity to start a new one',
    newMessage: 'New message',
    to: 'To',
    subject: 'Subject',
    message: 'Message',
    sendMessage: 'Send message',
    adjust: 'Adjust',
    add: 'Add',
    description: 'Description',
    amount: 'Amount',
    date: 'Date',
    total: 'Total',
    sendExpenseReport: 'Send expense report',
    addToOrder: 'Add to order',
    quantity: 'Quantity',
    newQuantity: 'New Quantity',
    reason: 'Reason',
    comment: 'Comment',
    startStore: 'Start store visit',
    resumeStore: 'Resume store visit',
    endStore: 'End store visit',
    endStoreActiveTask: 'Please end the active task before ending the store visit.',
    activityType: 'Activity Type',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    startOdo: 'Start Odometer',
    endOdo: 'End Odometer',
    distance: 'Distance',
    location: 'Location',
    destination: 'Destination',
    travelingMessage: 'You are now traveling.',
    close: 'Close',
    continue: 'Continue',
    cancel: 'Cancel',
    departingFrom: 'Departing From',
    departingStore: 'Departing Store',
    destinationStore: 'Destination Store',
    save: 'Save',
    start: 'Start',
    startTravel: 'Start Travel',
    stopTravel: 'Stop Travel',
    saveTravel: 'Save Travel',
    addActivity: 'Add activity',
    saveNewActivity: 'Save New Activity',
    stopSave: 'Stop & Save',
    delete: 'Delete',
    type: 'Type',
    requiredGeneric: 'Field is required',
    notBeforeNow: 'Cannot be scheduled before current time',
    startOverlapEnd: 'Start time cannot overlap end time',
    endOverlapStart: 'End time cannot overlap start time',
    betweenActivities: 'Cannot be between existing activities',
    overlapActivities: 'Cannot overlap existing activities',
    odometerSmaller: 'Reading must be smaller than end odometer',
    odometerLarger: 'Reading must be larger than start odometer',
    childrenSum: 'Total time of tasks cannot be greater than store visit',
    endOfDay: 'End of Day',
    endOfDayInfo: 'You are about to end your day if you proceed.',
    travelOverride: 'Exception - Do not apply 30/30 Mileage. (Requires AM approval) ',
    travelOverrideCan: 'Exception - Do not apply 20/20 Mileage. (Requires AM approval) ',
    payrollCertLang: 'Payroll Certification Language',
    endDay: 'End Day',
    recapPreview: 'Recap Preview',
    update: 'Update',
    updateLastTask: 'Update Last Task',
    options: {
      core: 'Core',
      merchandising: 'Merch',
      transfer: 'Transfer',
      atStore: 'At Store',
      unscheduledTasks: 'Unscheduled Tasks',
      minimumHourRequirement: 'Minimum Hour Requirement',
      cartFraming: 'Cart Framing',
      home: 'Home',
      warehouse: 'Warehouse',
      store: 'Store',
      other: 'Other',
      break: 'Break',
      paidBreak: 'Paid Break',
      virtualOnline: 'Virtual and On-Line',
      virtualTrainer: 'Virtual Trainer Activities',
      retailMerchCoach: 'Retail Merchandising Coach',
      operationSupport: 'Operation Support',
      recruitingDuties: 'Recruiting Duties',
      instore: 'INSTORE',
      cart: 'CART',
      merch: 'MERCH',
    },
    messages: {
      message: 'Message',
      reply: 'Reply',
      subject: 'Subject',
      departDestNotSame: 'Departing/Destination cannot be the same',
      storesNotSame: 'Departing/Destination stores cannot be the same',
      storesNotDefined: 'Store must be defined',
      locationNotNull: 'A location must be selected',
      noResults: 'No results',
      fieldNotNull: 'Field cannot be empty',
      aboveZero: 'Input must be above zero',
      notNegative: 'Input must not be negative',
      noDecimal: 'Input must be a whole number',
    },
    orderReasons: {
      neverReceivedOriginal: 'Never received Original',
      receivedPartialShipment: 'Received Partial Shipment',
      receivedIncorrectMaterials: 'Received incorrect materials',
      materialsReceivedDamaged: 'Materials received damaged',
      others: 'Other',
      lost: 'Lost',
      damaged: 'Damaged',
      found: 'Found',
      transfer: 'Rep-to-rep transfer',
      cycleCount: 'Cycle Count',
      recoveredAtStore: 'Recovered at Store',
    },
  },
  language: 'Language',
  menu: {
    home: 'Home',
    tasks: 'Tasks',
    stores: 'Stores',
    timeTracking: 'Time Tracking',
    inventory: 'Inventory',
    preferences: 'Preferences',
    messaging: 'Messaging',
    timeline: 'Activity Timeline',
    lastSynced: 'Last synced',
  },
  login: {
    welcome: 'Welcome to FHS',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    errorInvalid: 'Invalid username or password',
    errorCommunication: 'Unable to log in, please try again later',
    expired: 'Your request expired. Please try again shortly.',
    connection: 'There was an error connecting to the internet. Please try again shortly.',
    loggingIn: 'Logging in...',
  },
  data: {
    allData: 'All Data',
    item: 'item | items',
    noData: 'There is no data to display',
    noGroupData: 'There is no data in this group to display',
    filtering: {
      filter: 'Filter',
      addFilter: 'Add filter',
      applyFilter: 'Apply filter',
      groupBy: 'Group by',
      sortBy: 'Sort by',
      search: 'Search',
      addCondition: 'Add Condition',
      field: 'Field',
      operator: 'Operator',
      date: 'Date',
      value: 'Value',
      operators: {
        comparison: {
          equals: 'equals',
          notEqual: 'does not equal',
          greaterThan: 'greater than',
          lessThan: 'less than',
          is: 'is',
          isNot: 'is not',
          isEmpty: 'is empty',
          onDate: 'on date',
          onOrBefore: 'on or before date',
          onOrAfter: 'on or after date',
          beforeDate: 'before date',
          afterDate: 'after date',
          isTrue: 'is true',
          isFalse: 'is false',
          isAnyOf: 'is any of',
          isNotAnyOf: 'is not any of',
        },
        date: {
          exactDate: 'exact date',
          today: 'today',
          tomorrow: 'tomorrow',
          yesterday: 'yesterday',
          oneWeekPast: 'one week ago',
          oneWeekFuture: 'one week from now',
          oneMonthPast: 'one month ago',
          oneMonthFuture: 'one month from now',
        },
      },
    },
  },
  media: {
    takePhoto: 'Take Photo',
    clearPhotos: 'Clear Photos',
    savingPhoto: 'Saving Photo...',
    abortUpload: 'Abort Upload',
    error: 'Something went wrong capturing the photo, please try again.',
  },
  storeItems: {
    suggestEdit: 'Suggest an Edit',
    details: 'Details',
    survey: 'First Party Data',
    carts: 'Carts',
    pedestals: 'Pedestals',
    small_carts_1sd: 'Small 1 sided unit',
    small_carts_std: 'Small 2 sided unit',
    small_carts_thin: 'Small thin unit',
    large_carts_1sd: 'Large 1 sided unit',
    large_carts_std: 'Large 2 sided unit',
    liberty_pedestals: 'Liberty Pedestals',
    evolve_pedestals: 'Evolve Pedestals',
    other_pedestals: 'Other Pedestals',
    e10_pedestals: 'E10',
    p20_pedestals: 'P20',
    noAdPanel_pedestals: 'Liberty/Evolve No Ad Panel',
    manned_checkout_number: 'Manned Checkouts',
    self_checkout_number: 'Self Checkouts',
    no_of_coupon_zones: 'CZB',
    notes: 'Notes',
    store_items: 'Items',
    store_manager: 'Manager',
    class_of_trade: 'Class of Trade',
    report: 'Report a fact',
    tasks: 'Tasks',
    productLines: 'Product Lines',
    picklist: 'Picklist',
    recommendations: 'Recommendations',
    visiting: 'Visiting',
    contact_name: 'Manager',
    store_number: 'Store Number',
    chain_name: 'Chain Name',
    chain_short_name: 'Chain Short Name',
    end_survey: 'End Survey',
    update_survey: 'Update Survey',
  },
  taskProfile: {
    noTask:
      'The task could not be loaded. Please reboot FHS Next Gen and if the problem persists, contact your manager.',
    ad_qty_type: 'Ad Qty & Type',
    art_description: 'Art Description',
    artwork: 'Artwork',
    attachment: 'Attachment',
    cancelTask: 'Clear Task',
    checkInToStart: 'Check into the store to start this task',
    completed: 'Completed',
    endTask: 'End Task',
    errorSavingRecap: 'Something went wrong when trying to end the task. Please try again.',
    est_task_duration: 'Est Task Duration',
    includeRecap: 'Include Recap',
    instructions: 'Instructions',
    job_description: 'Job Description',
    job_id: 'Job ID',
    kit: 'Kit',
    open: 'Open',
    paused: 'Paused',
    pauseTask: 'Pause Task',
    placement_section: 'Placement Section',
    previous_ad_qty: 'Previous Ad Quantity',
    previous_inventory_item: 'Previous Inventory Item',
    previous_placement: 'Previous Placement',
    product_line: 'Product Line',
    resumeTask: 'Resume task',
    running: 'Running',
    showRecap: 'Show Recap',
    space_id: 'Space ID',
    startTask: 'Start task',
    submitted: 'Submitted',
    supplies_sent_to: 'Supplies Sent To',
    task_type: 'Task Type',
    task: 'Task',
    wave: 'Wave',
    desc_art_id: 'Description/Artwork ID',
    initial_image_rai: 'Initial Image Rai',
    inventory_item: 'Inventory Item',
    limited_quantity_buy: 'Limited Quantity Buy',
    maintain_image_rai: 'Maintain Image RAI',
    order_sales_id: 'Order Sales ID',
    previous_rai_code: 'Previous RAI',
    previous_ad_quantity: 'Previous Ad Quantity',
    quantity_installed: 'Quantity Installed',
    remove_image_rai: 'Remove Image Rai',
    special_instructions: 'Special Instructions',
    task_status: 'Status',
    value: 'Coupon Value',
    test_indicator: 'MPT',
    prev_item_installed: 'Previous Item Installed',
    previous_placement_id: 'Previous Placement',
    artwork_id: 'Artwork ID',
    previous_execution_timestamp_tz: 'Previous Execution Date',
  },
  tables: {
    tasks: 'Tasks',
    merchPlanner: 'Merch Planner',
    stores: 'All Stores',
    workView: 'Work View',
    balance: 'Balance',
    allItems: 'All Items',
    orders: 'Orders',
  },
  messaging: {
    offline: 'You are offline, messages will be sent/recieved when the device is connected.',
    noMessagesInbox: 'Your Inbox is empty.',
    noMessagesOutbox: 'Your Outbox is empty.',
    sentMessagesRemoved: 'Sent messages are automatically removed after 30 days',
    inbox: 'Inbox',
    outbox: 'Outbox',
    sent: 'Sent',
  },
}
